import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConferenciaService } from 'src/app/core/services/conferencia.service';
import { SubdominiosService } from 'src/app/core/services/dominios.service';
import { ParametrosService } from 'src/app/core/services/parametros.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import Swal from 'sweetalert2';
import { EventoConferenciaComponent } from '../evento-conferencia/evento-conferencia.component';

@Component({
  selector: 'app-conferencia',
  templateUrl: './conferencia.component.html',
  styleUrls: ['./conferencia.component.scss'],
})
export class ConferenciaComponent implements OnInit {
  public usuario = null;
  public id_param_evento = null;
  public eventoForm = null;
  public loginFromDemo = null;
  public empresa = null;
  public fecha_de_pago_subdominio = null;
  public creating = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EventoConferenciaComponent>,
    private svUtils: UtilsService,
    private svParams: ParametrosService,
    private svConferencias: ConferenciaService,
    private svUsuario: UsuarioService,
    private svDomain: SubdominiosService
  ) {}

  ngOnInit(): void {
    this.usuario = this.svUtils.getLoggedUser();

    this.loginFromDemo = localStorage.getItem('loginFromDemo');
    this.eventoForm = this.fb.group({
      nombre_evento: [null, [Validators.required]],
      descripcion_evento: [null, [Validators.required]],
    });
    this.getParameters();
    this.getCompany(this.usuario);
  }
  onCancel(): void {
    this.dialogRef.close();
  }

  getCompany(usuario) {
    if (usuario?.id_empresa_usuario) {
      this.svUsuario
        .getCompany(usuario?.id_empresa_usuario)
        .subscribe((resp) => {
          if (resp['status'] === 'success') {
            resp = resp['body']['data'][0];
            this.empresa = resp;
            this.fecha_de_pago_subdominio =
              this.empresa['fecha_pago_subdominio'];
            let fecha_convertida = new Date(this.fecha_de_pago_subdominio);
            let final_fecha_pago = null;
            let fecha_actual = Date.now();

            if (this.empresa['es_demo'] == 'No') {
              final_fecha_pago = fecha_convertida.setDate(
                fecha_convertida.getDate() + 30
              );
            } else {
              final_fecha_pago = fecha_convertida.setDate(
                fecha_convertida.getDate() + 1
              );
            }

            if (this.empresa['es_demo'] != 'demo_default') {
              if (fecha_actual > final_fecha_pago) {
                let subd = {
                  id_subdominio: this.empresa['id_subdominio'],
                  id_usuario_subdominio: this.empresa['id_usuario'],
                  cuenta_activa_subdominio: 'No',
                };

                this.svDomain.updateDomain(subd).subscribe((resp_subd) => {
                  if (resp_subd['result']['data'][0]) {
                    resp['cuenta_activa_subdominio'] =
                      resp_subd['result']['data'][0][
                        'cuenta_activa_subdominio'
                      ];
                  }
                });
              }
            }

            localStorage.setItem('empresa', JSON.stringify(resp));
          }
        });
    }
  }

  getParameters() {
    this.svParams.getTypeParameters().subscribe((reps) => {
      reps['body']['data'].filter((data) => {
        if (data['nombre_tipo_parametro'] === 'TIPO MUNDO') {
          this.svParams
            .getParameters(data['id_tipo_parametro'])
            .subscribe((rp) => {
              rp['body']['data'].filter((p) => {
                if (p['nombre_parametro'] == 'Conferencia') {
                  this.id_param_evento = p['id_parametro'];
                }
              });
            });
        }
      });
    });
  }
  generarRandom(num) {
    let characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.split(
          ''
        ),
      result = '';
    if (num > characters.length) return false;
    for (let i = 0; i < num; i++) {
      result += characters.splice(
        Math.floor(Math.random() * characters.length),
        1
      )[0];
    }
    return result.toLowerCase();
  }
  openConferenciaModal() {
    const dialogRef = this.dialog.open(ConferenciaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }
  counterDown(empresa) {
    this.creating = true;
    let oldDateObj = new Date();
    let newDateObj = new Date();
    newDateObj.setTime(oldDateObj.getTime() + 2 * 60 * 1000);
    let dias_a_sumar = 0;
    if (empresa['es_demo'] == 'No') {
      dias_a_sumar = 30;
    } else {
      dias_a_sumar = 5;
    }
    const meses = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ];
    const dias_semana = [
      'Domingo',
      'Lunes',
      'martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ];

    const fecha = new Date();
    fecha.setDate(fecha.getDate() + dias_a_sumar);
    let fecha_convertida =
      dias_semana[fecha.getDay()] +
      ', ' +
      fecha.getDate() +
      ' de ' +
      meses[fecha.getMonth()] +
      ' de ' +
      fecha.getUTCFullYear();

    let x = setInterval(function () {
      let now = new Date().getTime();
      let distance = newDateObj.getTime() - now;
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (distance > 0) {
        document.getElementById(
          'countDown'
        ).innerHTML = `${minutes} minutos con ${seconds} segundos`;
      }
      if (distance < 0) {
        this.creating = false;
        clearInterval(x);
        Swal.fire(
          'Operación existosa',
          `Tu evento ha sido creado de manera exitosa. Vence el ${fecha_convertida}`,
          'success'
        );
        setTimeout(() => {
          window.location.href = 'auth/home';
        }, 3000);
      }
    }, 1000);
  }

  addConferencia(conferencia_data, es_demo, empresa) {
    let event_data = {
      id_usuario_evento: this.usuario.id_usuario,
      id_conferencia_evento: null,
      nombre_evento: conferencia_data['nombre_conferencia'],
      descripcion_evento: conferencia_data['descripcion_conferencia'],
      subdominio_evento: conferencia_data['subdominio'],
      fecha_inicio_evento: 'fecha_inicio_evento',
      fecha_fin_evento: 'fecha_fin_evento',
      tipo_evento: 'Conferencia',
      abierto_evento: '1',
    };
    this.counterDown(empresa);

    this.svConferencias
      .addConferencia(conferencia_data)
      .subscribe((resp_conferencia) => {});
  }

  createEvent(form_data) {
    return;
    this.creating = true;
    let es_demo = false;
    let es_demo_text = 'No';
    let empresa = JSON.parse(localStorage.getItem('empresa'));

    if (empresa) {
      let subdominio = empresa.subdominio_empresa_usuario;
      if (empresa['es_demo'] == 'Si') {
        es_demo = true;
        es_demo_text = 'Si';
        subdominio = this.generarRandom(6);
      }
      if (empresa['es_demo'] == 'demo_default') {
        es_demo = true;
        es_demo_text = 'Si';
        subdominio = 'https://demo.infoverses.com';
      }

      let conferencia_data = {
        es_demo: es_demo_text,

        id_usuario_conferencia: this.usuario.id_usuario,
        id_empresa_usuario_conferencia: empresa['id_empresa_usuario'],
        logo_conferencia: null,
        nombre_conferencia: form_data['nombre_evento'],
        descripcion_conferencia: form_data['descripcion_evento'],
        tipo_conferencia: ' conferencia1',
        color_paredes_conferencia: '#062c30',
        tipo_distribucion: '1',
        textura_suelo_conferencia: '#062c30',
      };

      this.svUsuario.getDemo(this.usuario.id_usuario).subscribe((resp_demo) => {
        if (resp_demo['body']) {
          let there_are_data = false;
          if (resp_demo['body']['status'] === 'success') {
            resp_demo = resp_demo['body']['demo'][0];
            there_are_data = true;
          }
          if (there_are_data) {
            let fecha_de_registro_demo = resp_demo['fecha_de_registro_demo'];
            let fecha_convertida = new Date(fecha_de_registro_demo);
            let final_fecha_de_registro = null;
            let fecha_actual = Date.now();

            final_fecha_de_registro = fecha_convertida.setDate(
              fecha_convertida.getDate() + 1
            );

            if (
              fecha_actual < final_fecha_de_registro &&
              empresa['es_demo'] == 'demo_default'
            ) {
              this.creating = false;
              Swal.fire(
                'Plan Demo limitado',
                'Debes esperar 24 horas desde la creación de un evento, para agregar uno nuevo',
                'warning'
              );
              return;
            }
          }
          if (
            empresa['es_demo'] == 'Si' ||
            empresa['es_demo'] == 'demo_default'
          ) {
            conferencia_data['cantidad_de_asistentes'] = '10';
            this.addConferencia(conferencia_data, es_demo, empresa);
          }
        }
      });
      if (empresa['es_demo'] == 'No') {
        this.addConferencia(conferencia_data, false, empresa);
      }
    } else {
      this.creating = false;
      Swal.fire(
        'Datos de la empresa',
        'No fue posible obtener los datos de la empresa!',
        'warning'
      );
    }
  }
}
